/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_OthersInputs */

const id_nav_others = /** @type {(inputs: Nav_OthersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lainnya`)
};

const ms_nav_others = /** @type {(inputs: Nav_OthersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lain-lain`)
};

const da_nav_others = /** @type {(inputs: Nav_OthersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Andre`)
};

const de_nav_others = /** @type {(inputs: Nav_OthersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Andere`)
};

const en_us2_nav_others = /** @type {(inputs: Nav_OthersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Others`)
};

const es_es2_nav_others = /** @type {(inputs: Nav_OthersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Otros`)
};

const es_mx2_nav_others = /** @type {(inputs: Nav_OthersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Otros`)
};

const fil_nav_others = /** @type {(inputs: Nav_OthersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Iba Pa`)
};

const fr_nav_others = /** @type {(inputs: Nav_OthersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Autres`)
};

const it_nav_others = /** @type {(inputs: Nav_OthersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Altri`)
};

const hu_nav_others = /** @type {(inputs: Nav_OthersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Egyebek`)
};

const nl_nav_others = /** @type {(inputs: Nav_OthersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anderen`)
};

const no_nav_others = /** @type {(inputs: Nav_OthersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Andre`)
};

const pl_nav_others = /** @type {(inputs: Nav_OthersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inne`)
};

const pt_br2_nav_others = /** @type {(inputs: Nav_OthersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Outros`)
};

const pt_nav_others = /** @type {(inputs: Nav_OthersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Outros`)
};

const ro_nav_others = /** @type {(inputs: Nav_OthersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Altele`)
};

const fi_nav_others = /** @type {(inputs: Nav_OthersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Muut`)
};

const sv_nav_others = /** @type {(inputs: Nav_OthersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Andra`)
};

const vi_nav_others = /** @type {(inputs: Nav_OthersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Khác`)
};

const tr_nav_others = /** @type {(inputs: Nav_OthersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diğer`)
};

const cs_nav_others = /** @type {(inputs: Nav_OthersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ostatní`)
};

const bg_nav_others = /** @type {(inputs: Nav_OthersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Други`)
};

const ru_nav_others = /** @type {(inputs: Nav_OthersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Другое`)
};

const uk_nav_others = /** @type {(inputs: Nav_OthersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Інше`)
};

const ar_nav_others = /** @type {(inputs: Nav_OthersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`أخرى`)
};

const hi_nav_others = /** @type {(inputs: Nav_OthersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`अन्य`)
};

const th_nav_others = /** @type {(inputs: Nav_OthersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`อื่น ๆ`)
};

const ja_nav_others = /** @type {(inputs: Nav_OthersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`その他`)
};

const zh_cn2_nav_others = /** @type {(inputs: Nav_OthersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`其他`)
};

const zh_hant1_nav_others = /** @type {(inputs: Nav_OthersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`其他`)
};

const ko_nav_others = /** @type {(inputs: Nav_OthersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`기타`)
};

/**
* | output |
* | --- |
* | "Others" |
*
* @param {Nav_OthersInputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const nav_others = /** @type {((inputs?: Nav_OthersInputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_OthersInputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_nav_others(inputs)
	if (locale === "ms") return ms_nav_others(inputs)
	if (locale === "da") return da_nav_others(inputs)
	if (locale === "de") return de_nav_others(inputs)
	if (locale === "en-US") return en_us2_nav_others(inputs)
	if (locale === "es-ES") return es_es2_nav_others(inputs)
	if (locale === "es-MX") return es_mx2_nav_others(inputs)
	if (locale === "fil") return fil_nav_others(inputs)
	if (locale === "fr") return fr_nav_others(inputs)
	if (locale === "it") return it_nav_others(inputs)
	if (locale === "hu") return hu_nav_others(inputs)
	if (locale === "nl") return nl_nav_others(inputs)
	if (locale === "no") return no_nav_others(inputs)
	if (locale === "pl") return pl_nav_others(inputs)
	if (locale === "pt-BR") return pt_br2_nav_others(inputs)
	if (locale === "pt") return pt_nav_others(inputs)
	if (locale === "ro") return ro_nav_others(inputs)
	if (locale === "fi") return fi_nav_others(inputs)
	if (locale === "sv") return sv_nav_others(inputs)
	if (locale === "vi") return vi_nav_others(inputs)
	if (locale === "tr") return tr_nav_others(inputs)
	if (locale === "cs") return cs_nav_others(inputs)
	if (locale === "bg") return bg_nav_others(inputs)
	if (locale === "ru") return ru_nav_others(inputs)
	if (locale === "uk") return uk_nav_others(inputs)
	if (locale === "ar") return ar_nav_others(inputs)
	if (locale === "hi") return hi_nav_others(inputs)
	if (locale === "th") return th_nav_others(inputs)
	if (locale === "ja") return ja_nav_others(inputs)
	if (locale === "zh-CN") return zh_cn2_nav_others(inputs)
	if (locale === "zh-Hant") return zh_hant1_nav_others(inputs)
	return ko_nav_others(inputs)
});
export { nav_others as "nav.others" }